/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterMitInfosDto } from '../../models/mitarbeiter-mit-infos-dto';

export interface GetSingleMitarbeiterInfos$Plain$Params {

/**
 * Id des Mitarbeiters von dem die MitarbeiterInfos geladen werden sollen
 */
  mitarbeiterId: string;
}

export function getSingleMitarbeiterInfos$Plain(http: HttpClient, rootUrl: string, params: GetSingleMitarbeiterInfos$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterMitInfosDto>> {
  const rb = new RequestBuilder(rootUrl, getSingleMitarbeiterInfos$Plain.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterMitInfosDto>;
    })
  );
}

getSingleMitarbeiterInfos$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/infos';
